<div class="card-header mb-4">
    <div class="title-section">
        <h2 class="header-title">Cuentas Contables</h2>
        <div class="client-info">
            <p>
                Clave: <strong>{{ this.model.sEmpresa }}</strong>
            </p>
            <p>
                Empresa: <strong>{{ this.model.sNombre }}</strong>
            </p>
            <p>
                Catalogo: <strong>{{ this.model.sTipo }}</strong>
            </p>
        </div>
    </div>
    <div class="button-section">
        <button mat-flat-button class="btn-back" (click)="close()" appPermissionControl="P289B0001">
            <mat-icon>arrow_back</mat-icon>
            Atrás
        </button>
    </div>
</div>

<div class="button-section" *ngIf="model">
    <div class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P289K0001">
    </div>
    <button mat-stroked-button (click)="abrirModal()" class="btn-new" appPermissionControl="P289B0002">
        <mat-icon aria-hidden="false" aria-label="Domicilios" class="icon-btn">add</mat-icon>
        Nuevo
    </button>
</div>

<hr />
<p-table
    #dt
    [value]="dataSource"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [globalFilterFields]="['sCuenta', 'sDescripcion', 'sClaveContabilidadDeb', 'sClaveContabilidadCre']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
 appPermissionControl="P289T0001">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="th-prime" pSortableColumn="sCuenta" appPermissionControl="P289C0001">
                Cuenta
                <p-sortIcon field="sCuenta"></p-sortIcon>
            </th>
            <th class="th-prime" pSortableColumn="sDescripcion" appPermissionControl="P289C0002">
                Descripción
                <p-sortIcon field="sDescripcion"></p-sortIcon>
            </th>
            <th class="th-prime" pSortableColumn="sClaveContabilidadDeb" appPermissionControl="P289C0003">
                Clave Contabilización Débito
                <p-sortIcon field="sClaveContabilidadDeb"></p-sortIcon>
            </th>
            <th class="th-prime" pSortableColumn="sClaveContabilidadCre" appPermissionControl="P289C0004">
                Clave Contabilización Crédito
                <p-sortIcon field="sClaveContabilidadCre"></p-sortIcon>
            </th>
            <th class="th-prime" appPermissionControl="P289C0005">Acciones</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td class="td-prime">{{ rowData.sCuenta }}</td>
            <td class="td-prime">{{ rowData.sDescripcion }}</td>
            <td class="td-prime">{{ rowData.sClaveContabilidadDeb }}</td>
            <td class="td-prime">{{ rowData.sClaveContabilidadCre }}</td>
            <td class="td-prime text-center">
                <div class="d-flex gap-2 justify-content-center">
                    <button
                        pButton
                        icon="pi pi-eye"
                        class="p-button-rounded p-button-info p-button-text"
                        (click)="editCuenta(rowData)"
                        pTooltip="Editar cuenta"
                     appPermissionControl="P289B0003"></button>
                    <button
                        pButton
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-danger p-button-text"
                        (click)="deleteCuenta(rowData)"
                        pTooltip="Eliminar cuenta"
                     appPermissionControl="P289B0004"></button>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="text-center td-prime">No hay datos para mostrar</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog 
    header="{{ isEdit ? 'Editar Cuenta' : 'Nueva Cuenta' }}" 
    [modal]="true" 
    [draggable]="false"
    [(visible)]="newModal" 
    [style]="{ width: '30rem' }" 
    [resizable]="false"
    (onHide)="cerrarModal()"
>
    <br />
    <div class="form-row" [formGroup]="formDataCuentas">
        <div class="form-field flex-grow-1">
            <label>Cuenta *</label>
            <input type="text" formControlName="sCuenta" class="form-control" placeholder="Ingrese cuenta" appPermissionControl="P289K0002">
            <small class="text-danger" *ngIf="formDataCuentas.get('sCuenta')?.errors?.required && formDataCuentas.get('sCuenta')?.touched">
                La cuenta es requerida
            </small>
        </div>
        <div class="form-field col-12">
            <label>Descripción</label>
            <input type="text" formControlName="sDescripcion" class="form-control" placeholder="Ingrese descripción" appPermissionControl="P289K0003">
        </div>
        <div class="form-field">
            <label>C.C. Débito</label>
            <input type="text" formControlName="sClaveContabilidadDeb" class="form-control" placeholder="Ingrese clave contabilización débito" appPermissionControl="P289K0004">
        </div>
        <div class="form-field">
            <label>C.C. Crédito</label>
            <input type="text" formControlName="sClaveContabilidadCre" class="form-control" placeholder="Ingrese clave contabilización crédito" appPermissionControl="P289K0005">
        </div>
    </div>
    <br />
    <div class="button-section" style="justify-content: end" *ngIf="model">
        <button
            mat-stroked-button
            (click)="isEdit ? updateCuenta() : addCuenta()"
            class="btn-success"
            [disabled]="formDataCuentas.invalid"
         appPermissionControl="P289B0005">
            <mat-icon aria-hidden="false" aria-label="Guardar" class="icon-btn">check</mat-icon>
            {{ isEdit ? "Actualizar" : "Guardar" }}
        </button>
        <button mat-stroked-button (click)="openCustomizables()" class="btn-search" *ngIf="isEdit" appPermissionControl="P289B0006">
            <mat-icon aria-hidden="false" aria-label="Domicilios" class="icon-btn">settings</mat-icon>
            Customizables
        </button>
    </div>
</p-dialog>
